import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from './module';

const AVAILABILITY_BLOCKS_INIT = prefix('AVAILABILITY_BLOCKS_INIT');

export const [AVAILABILITY_BLOCKS_INIT_STARTED, AVAILABILITY_BLOCKS_INIT_SUCCEEDED, AVAILABILITY_BLOCKS_INIT_FAILED] =
    createAsyncActionTypes(AVAILABILITY_BLOCKS_INIT);

const AVAILABILITY_ADJUSTMENT_UPDATE = prefix('AVAILABILITY_ADJUSTMENT_UPDATE');

export const [
    AVAILABILITY_ADJUSTMENT_UPDATE_STARTED,
    AVAILABILITY_ADJUSTMENT_UPDATE_SUCCEEDED,
    AVAILABILITY_ADJUSTMENT_UPDATE_FAILED,
] = createAsyncActionTypes(AVAILABILITY_ADJUSTMENT_UPDATE);

export const SERVICE_AVAILABILITIES_FETCH = prefix('SERVICE_AVAILABILITIES_FETCH');

export const [
    SERVICE_AVAILABILITIES_FETCH_STARTED,
    SERVICE_AVAILABILITIES_FETCH_SUCCEEDED,
    SERVICE_AVAILABILITIES_FETCH_FAILED,
] = createAsyncActionTypes(SERVICE_AVAILABILITIES_FETCH);

export const FORM_MODE_CHANGED = prefix('FORM_MODE_CHANGED');
export const MONTH_CHANGED = prefix('MONTH_CHANGED');
export const WAS_RELEASE_OVERRIDEN = prefix('WAS_RELEASE_OVERRIDEN');

export const DESTROY_AVAILABILITY_BLOCK_SCOPE = prefix('DESTROY_AVAILABILITY_BLOCK_SCOPE');
